import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead, option) {
    let options: AbstractControlOptions = {};

    const yearlyEarning = option?.earningsRepartition?.amount;
    const maxMonthlySaving = yearlyEarning ? yearlyEarning / 12 : null;

    return this.formBuilder.group(
      {
        accountInformations: this.formBuilder.group({
          monthlySaving: [
            entity?.accountInformations?.monthlySaving || 0,
            [
              Validators.required,
              Validators.min(0),
              Validators.max(maxMonthlySaving),
            ],
          ],
          liquidity: [
            entity?.accountInformations?.liquidity || 0,
            [Validators.required, Validators.min(0)],
          ],
          epargnePrecaution: [
            entity?.accountInformations?.epargnePrecaution || 0,
            [Validators.required, Validators.min(0)],
          ],
        }),
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  get accountInformations() {
    return this.form.get('accountInformations') as UntypedFormArray;
  }
  extract() {
    return this.form.value;
  }
}
